export const LOADING_SPINNER_SHOW_MUTATION='[mutations] show loading spinner';